var map = {
	"./A.png": "3ba6",
	"./ASpace.png": "377e",
	"./B.png": "17fc",
	"./BSpace.png": "7b09",
	"./DownWear.png": "52e0",
	"./Kerchief.png": "79c3",
	"./MY.png": "b1d2",
	"./Malaysia.png": "cf64",
	"./RUS.png": "4283",
	"./Russia.png": "f0b5",
	"./arrow.png": "060e",
	"./barCode/Carton.png": "d4bf",
	"./barCode/CartonBarCode.png": "a778",
	"./barCode/product.png": "11da",
	"./barCode/productCode.png": "14a1",
	"./bg.png": "5607",
	"./bg2.png": "bb88",
	"./dialogue/student-tip.png": "eb8f",
	"./dialogue/teacher-tip.png": "43bf",
	"./dialogue/teacher.png": "634e",
	"./handleOrders/A.png": "7fe3",
	"./handleOrders/B.png": "98a8",
	"./handleOrders/arrow-right.png": "f3ea",
	"./handleOrders/bg.png": "bd70",
	"./handleOrders/map.png": "920f",
	"./handleOrders/product.png": "efb0",
	"./jiantou.png": "71e7",
	"./logisticsDelivery/dhl.png": "883b",
	"./logisticsDelivery/e.png": "850d",
	"./logisticsDelivery/san.png": "054a",
	"./logo.png": "a1d8",
	"./putInStorage/ASpace-putin.png": "423c",
	"./putInStorage/BSpace-putin.png": "c540",
	"./putInStorage/MY-flag.png": "c105",
	"./putInStorage/RUS-flag.png": "cd3b",
	"./putInStorage/product.png": "5925",
	"./signFor/MY.png": "6aa2",
	"./signFor/RUS.png": "17d1",
	"./simulationCase/one.png": "abd9",
	"./simulationCase/three.png": "a53d",
	"./simulationCase/two.png": "bf5d",
	"./sweep/code.png": "4394",
	"./sweep/laba.png": "1a6e",
	"./sweep/saomiaoqiang.png": "e57f",
	"./tj.png": "491c",
	"./yrf.png": "43ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";